import { render, staticRenderFns } from "./IveriPaymentFailure.vue?vue&type=template&id=6a1ff99c&scoped=true"
import script from "./IveriPaymentFailure.vue?vue&type=script&lang=js"
export * from "./IveriPaymentFailure.vue?vue&type=script&lang=js"
import style0 from "./IveriPaymentFailure.vue?vue&type=style&index=0&id=6a1ff99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ff99c",
  null
  
)

export default component.exports